import React, { forwardRef } from "react";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const CustomButton = forwardRef((props, ref) => <Button ref={ref} {...props} color="primary" variant="contained" />);

CustomButton.displayName = "CustomPrimaryButton";

export default withStyles((theme) => ({
  containedPrimary: {
    "& .MuiButton-label": {
      fontWeight: 500,
      borderRadius: 22,

      fontSize: 22,
      [theme.breakpoints.between(1024, 1320)]: {
        fontSize: 20,
      },
    },
  },
}))(CustomButton);
